import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControlLabel, Grid, Grow, MenuItem, Select, TextField, Toolbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { setSelectedAlbumId, useAlbums, invalidate } from "./ListAlbumSlice";
import styles from "./ListAlbum.module.css";
import * as Media from '../media/mediaSlice'
import clsx from "clsx";
import session from "../../app/Session";
import AlbumCard from "./AlbumCard";
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';
import { showAlbumModal } from '../../app/appSlice';
import { colors } from '../../Theme';
import { useState } from "react";
import { Label, Share } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { getApiError, getService } from "../../app/api";
import { AlbumsService } from "../../api/services";
import { useSnackbar } from "notistack";


export default function ListAlbum() {
    const { t, i18n } = useTranslation();
    let { dispatch, state } = useAlbums();
    let navigate = useNavigate();
    let [ shareAlbumId, setShareAlbumId] = useState<string|null>(null);
    let [action, setAction] = useState<string|null>(null);

    const token = session.getToken();

    function onView(albumId: string) {
        dispatch(setSelectedAlbumId(albumId));
        dispatch(Media.invalidate(true));
        dispatch(Media.setAlbumId({ albumId }));
        navigate(`/album/${albumId}`, { replace: true });
    }

    async function deleteAlbum(albumId: string) {
        dispatch(setSelectedAlbumId(undefined));
        dispatch(invalidate(true));
    }

    function onShare(albumId: string) {
        setShareAlbumId(albumId);
    }

    return (
        <Grow
            in={true}
            style={{ transformOrigin: '0 0 0' }}
            timeout={{ enter: 500, exit: 500 }}
        >
        <Box className={styles.root}>
            {state.invalidated === true && (
                <div className="progress-indicator">
                    <CircularProgress size="5rem" />
                </div>
            )}
            <Toolbar variant="dense">
                <Box sx={{ flexGrow: 1 }}>
                    { session.canCreateMedia() && (
                        <Button
                            color="primary"
                            onClick={() => dispatch(showAlbumModal(true))}
                            startIcon={<AddIcon />}
                            size="large" >
                            {t('menu.new-album')}
                        </Button>
                    )}
                </Box>
            </Toolbar>
            <Grid container spacing={2} className={clsx(state.invalidated === true ? 'content-loading' : undefined, styles.container)} >
                {state.albums.map(item => {
                    return (
                        <Grid item key={item.id} xs={12} md={4} lg={3} >
                            <AlbumCard item={item} onView={onView} onDeleted={deleteAlbum} token={token} onShare={onShare} />
                        </Grid>
                    );
                })}
            </Grid>
          {shareAlbumId && <ShareAlbum albumId={shareAlbumId} onClose={() => setShareAlbumId(null)} /> }            
        </Box>
        </Grow>
    );
}

function ShareAlbum({ albumId, onClose }: { albumId: string, onClose: () => void }) {
    const { t } = useTranslation();
    const [email, setEmail] = useState<string>('');
    const [role, setRole] = useState<string>('member');
    const [action, setAction] = useState<string|null>(null);
    const { enqueueSnackbar } = useSnackbar();

    async function share() {
        try {
            setAction('share');
            let srv = getService(AlbumsService);
            await srv.shareAlbum({ albumId, email, role });
            enqueueSnackbar(t('Album shared successfully!'), { variant: 'success' });
            onClose();
        }catch (error:any) {
            enqueueSnackbar(t('Error sharing album: {{error}}', { error:getApiError(error) }), { variant: 'error' });   
        } 
        finally {
            setAction(null);
        }
    }

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle>{t('Share Album')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {t('To share this album, please enter the email address here.')}
                </DialogContentText>
                <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="email"
                    label={t('Email Address')}
                    type="email"
                    fullWidth
                    variant="standard"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <FormControlLabel
                    control={
                        <Select value={role} onChange={(e) => setRole(e.target.value)} fullWidth={true} variant="standard">
                            <MenuItem value="member">{t('Member')}</MenuItem>
                            <MenuItem value="guest">{t('Guest')}</MenuItem>
                            <MenuItem value="owner">{t('Owner')}</MenuItem>
                        </Select>
                    }
                    label={t('Role')}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t('Cancel')}</Button>
                <LoadingButton
                    variant="text"
                    loading={action === 'share'}
                    loadingPosition="start"
                    color="primary"
                    onClick={share}>
                    {t('Share')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}